// It is a safeguard against multiple instances / versions of the library
// being loaded into environment by mistake (e.g. because of different
// packages pinning down different exact versions of the lib, thus preventing
// a proper dedupe and using a single common library version).
if (global.REACT_UTILS_LIBRARY_LOADED) {
  throw Error('React utils library is already loaded');
} else global.REACT_UTILS_LIBRARY_LOADED = true;

export {
  type AsyncCollectionLoaderT,
  type AsyncCollectionT,
  type AsyncDataEnvelopeT,
  type AsyncDataLoaderT,
  type ForceT,
  GlobalStateProvider,
  type UseAsyncDataOptionsT,
  type UseAsyncDataResT,
  type UseGlobalStateResT,
  type ValueOrInitializerT,
  getGlobalState,
  newAsyncDataEnvelope,
  useAsyncCollection,
  useAsyncData,
  useGlobalState,
  withGlobalStateType,
} from '@dr.pogodin/react-global-state';

export * from 'components';

export {
  type BeforeRenderResT,
  type BeforeRenderT,
  type ConfigT,
  type ServerSsrContext,
  type ServerT,
} from './server';

export {
  Barrier,
  Cached,
  Emitter,
  type Listener,
  type ObjectKey,
  Semaphore,
  THEME_COMPOSE,
  THEME_PRIORITY,
  type Theme,
  ThemeProvider,
  assertEmptyObject,
  getConfig,
  getSsrContext,
  isomorphy,
  splitComponent,
  time,
  useTheme,
  webpack,
  withRetries,
} from 'utils';
